
<div class="input-group">
    <input #NextFile
           type="file"
           class="form-control"
           (input)="$any($event.target).blur()"
    />
    <button type="button"
            class="btn btn-primary"
            (click)="UploadFile()"
            [disabled]="NextFile.files.length == 0">
        Upload
    </button>
</div>